// extracted by mini-css-extract-plugin
module.exports = {"container":"OverlayModal_container__EasAp","content":"OverlayModal_content__3OhZt","icon":"OverlayModal_icon__6ORH7"};